import { depluralize } from './depluralize.js';
import { articles, unitAbbreviations } from './lists.js';
export function unitParser(rawInput) {
    let input = normalizeInput(rawInput);
    // expand known abbreviations
    const matchingAbbreviation = unitAbbreviations.find(([abbreviation]) => {
        if (input.trim() === abbreviation ||
            depluralize(input.trim()) === abbreviation)
            return true;
        return false;
    });
    if (matchingAbbreviation) {
        return matchingAbbreviation[1];
    }
    // discard leading or trailing articles
    let articleMatch = articles.find((a) => input.startsWith(a + ' '));
    if (articleMatch) {
        input = input.slice(articleMatch.length);
    }
    articleMatch = articles.find((a) => input.endsWith(' ' + a));
    if (articleMatch) {
        input = input.slice(0, -articleMatch.length);
    }
    return input.trim();
}
function normalizeInput(input) {
    // remove any trailing punctuation
    // eslint-disable-next-line no-useless-escape
    return input.replace(/[\.,;:]$/, '');
}
//# sourceMappingURL=unitParser.js.map